import { ChangeDetectorRef, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NotifCanalResource, NotificationWizardResource, NotificationWizardSteps } from '../notification-wizard-type';

@Component({
    selector: 'app-notification-wizard-canal',
    templateUrl: './notification-wizard-canal.component.html',
    standalone: false
})
export class NotificationWizardCanalComponent implements OnInit {
    @Output() saveEmitter: EventEmitter<NotifCanalResource> = new EventEmitter<NotifCanalResource>();

    selectedCanal?: NotifCanalResource;
    canals?: NotifCanalResource[];
    notificationWizard: NotificationWizardResource;

    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
    ) {
        if (sessionStorage.getItem('notificationWizard')) {
            // @ts-ignore
            this.notificationWizard = JSON.parse(sessionStorage.getItem('notificationWizard')) as NotificationWizard;
        } else {
            this.notificationWizard = {};
        }
    }

    async ngOnInit(): Promise<void> {

        this._changeDetectorRef.markForCheck();
    }

    save(selectedCanal: NotifCanalResource) {
        this.selectedCanal = selectedCanal;
        this.notificationWizard.step = NotificationWizardSteps.Filter;
        sessionStorage.setItem('notificationWizard', JSON.stringify(this.notificationWizard));
        this.saveEmitter.emit(this.selectedCanal);
    }
}
